import { isNil } from 'lodash-es';
import { api } from '../commonApi';
import { setCsrfToken } from '../auth/authSlice';

const BASE_USERS_URL = `/users`;

export const usersApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getMe: builder.query<any, void>({
			query: () => {
				return `${BASE_USERS_URL}/me`;
			},
			providesTags: ['User'],
		}),
		upsertGuest: builder.mutation<{ csrfToken: string }, void>({
			query: () => {
				return {
					url: `${BASE_USERS_URL}/guest`,
					method: 'POST',
				};
			},
			onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
				const response = await queryFulfilled;

				const csrfToken = response?.data?.csrfToken;

				dispatch(setCsrfToken({ csrfToken: csrfToken ?? null }));
			},
		}),
		elevateGuestToUser: builder.mutation<{ success: boolean }, { jwtToken?: string }>({
			query: ({ jwtToken }) => {
				return {
					url: `${BASE_USERS_URL}/elevateGuestToUser`,
					method: 'POST',
					// If a JWT token is provided, it should be set in the Authorization header
					headers: !isNil(jwtToken) ? { Authorization: `Bearer ${jwtToken}` } : {},
				};
			},
			invalidatesTags: ['User'],
		}),
		getAccessToken: builder.mutation<{ token: string; expiresAt: string }, void>({
			query: () => {
				return {
					url: `${BASE_USERS_URL}/stream-token`,
					method: 'POST',
				};
			},
		}),
		createUserOrderSession: builder.mutation<{ id: string }, { tableSessionId?: string }>({
			query: ({ tableSessionId }) => {
				return {
					url: `${BASE_USERS_URL}/createUserOrderSession`,
					method: 'POST',
					body: !isNil(tableSessionId) ? { tableSessionId } : {},
				};
			},
		}),
		getActiveSessions: builder.query<{ tableSessionId: string; userOrderSessionId: string }, void>({
			query: () => {
				return `${BASE_USERS_URL}/activeSessions`;
			},
			providesTags: ['UserActiveSessions'],
		}),
	}),
});

export const {
	useLazyGetActiveSessionsQuery,
	useGetMeQuery,
	useUpsertGuestMutation,
	useElevateGuestToUserMutation,
	useGetAccessTokenMutation,
	useCreateUserOrderSessionMutation,
} = usersApi;
